import { render, staticRenderFns } from "./FakeUploader.vue?vue&type=template&id=2489f25a&"
import script from "./FakeUploader.vue?vue&type=script&lang=js&"
export * from "./FakeUploader.vue?vue&type=script&lang=js&"
import style0 from "./FakeUploader.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports